import React from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  TextField,
  Stack,
} from "@mui/material";
import toast from "react-hot-toast";
import { sendEmail } from "requests/SendEmail";
import { sendWhatsapp } from "requests/SendWhatsapp";

interface Props {
  open: boolean;
  onClose: () => void;
  onDownload: () => void;
  onSendWhatsApp: () => void;
  defaultEmail: string;
  formId: number;
  userId: string;
  userWpp: string;
}

export const PostSubmitModal: React.FC<Props> = ({
  open,
  onClose,
  onDownload,
  onSendWhatsApp,
  defaultEmail,
  formId,
  userId,
  userWpp,
}) => {
  const [customEmail, setCustomEmail] = React.useState("");

  React.useEffect(() => {
    if (open && defaultEmail) {
      setCustomEmail(defaultEmail);
    }
  }, [open, defaultEmail]);

  const handleSendEmail = async () => {
    if (!customEmail) return;

    try {
      const { status } = await sendEmail(
        {
          email_destinatario: customEmail,
          formulario_id: formId,
          id: userId,
        },
        userId
      );

      if ([200, 201].includes(status)) {
        toast.success(`E-mail enviado para ${customEmail}`);
        onClose();
      } else {
        toast.error("Erro ao enviar e-mail");
      }
    } catch (e) {
      console.log(e);
      toast.error("Erro ao enviar e-mail");
    }
  };

  const handleSendWhatsApp = async () => {
    if (!customEmail) return;

    try {
      const { status } = await sendWhatsapp(
        {
          numero_destinatario: userWpp,
          formulario_id: formId,
          id: userId,
        },
        userId
      );

      if ([200, 201].includes(status)) {
        toast.success(`Mensagem enviado para ${userWpp}`);
        onClose();
      } else {
        toast.error("Erro ao enviar mensagem");
      }
    } catch (e) {
      console.log(e);
      toast.error("Erro ao enviar mensagem");
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 4,
          borderRadius: 2,
          width: 400,
          boxShadow: 24,
        }}
      >
        <Typography variant="h6" mb={2}>
          O que deseja fazer agora?
        </Typography>

        <Stack spacing={2}>
          <Button variant="contained" color="primary" onClick={onDownload}>
            Baixar PDF
          </Button>

          <Box>
            <Typography variant="subtitle1" mb={1}>
              Enviar por e-mail
            </Typography>

            <TextField
              fullWidth
              margin="dense"
              label="Digite o e-mail"
              type="email"
              value={customEmail}
              onChange={(e) => setCustomEmail(e.target.value)}
            />

            <Button
              variant="outlined"
              color="primary"
              fullWidth
              sx={{ mt: 1 }}
              onClick={handleSendEmail}
              disabled={!customEmail}
            >
              Enviar E-mail
            </Button>
          </Box>

          {userWpp ? (
            <Button
              variant="contained"
              color="success"
              onClick={handleSendWhatsApp}
            >
              Enviar por WhatsApp
            </Button>
          ) : (
            ""
          )}
        </Stack>
      </Box>
    </Modal>
  );
};
